module.exports = __webpack_public_path__ + "static/media/zone3.6c29f9dd.png";